import type { FileType } from '~/types';
import type { PartnerConfigModel } from '~/types/branding/partner-config';

export const useBrandingStore = defineStore('branding', {
  state: () => ({
    activeTab: undefined as string | undefined,
    horizontalLogoUrl: undefined as string | undefined,
    squareLogoUrl: undefined as string | undefined,
    uploadedHorizontalLogo: undefined as FileType | undefined,
    uploadedSquareLogo: undefined as FileType | undefined,
    isUploadMode: false as boolean,
    partnerConfig: undefined as PartnerConfigModel | undefined,
    productionPrimaryColor: '#335584' as string,
    productionSecondaryColor: '#59EE7E' as string,
    isResetLoading: false as boolean,
    inputDesign: 'flat' as string,
    inputBorderRadius: 'rounded' as string
  })
});
